export const en = {
    // --- Direction & Formatting ---
    dir: 'ltr',
    align: 'left',

    // --- Auth & Security ---
    loginTab: "Login",
    signupTab: "Sign Up",
    companyName: "Company Name",
    userName: "Username",
    phoneNumber: "Phone Number", 
    email: "Email Address",
    password: "Password",
    loginBtn: "LOG IN",
    signupBtn: "SIGN UP",
    processing: "Processing...",
    forgetPassLink: "Forgot password?",
    resetTitle: "Reset Password",
    resetSub: "Enter your email to receive a reset link",
    yourEmail: "Your email",
    sendLinkBtn: "Send Link",
    sending: "Sending...",
    backToLogin: "Back to Login",
    loginError: "Invalid email or password",
    signupSuccess: "Registration successful!",
    signupError: "This company is already registered in our system.",
    forgotSuccess: "📩 Reset link has been sent to your email",
    forgotError: "Failed to send request, please check input data",
    otpTitle: "Security Verification",
    otpSub: "We detected a login attempt from a new device. Please enter the one-time verification code (OTP) sent to your email.",
    otpPlaceholder: "Enter 6-digit code",
    verifyBtn: "VERIFY CODE & LOGIN",
    verifying: "Verifying...",

    // --- Password Activation ---
    activateTitle: 'Set Account Password',
    activateSubtitle: 'Welcome! Please choose a username and secure password to activate your system account.',
    labelUser: 'Username',
    placeholderUser: 'Enter username',
    labelNew: 'New Password',
    labelConfirm: 'Confirm Password',
    btnActivate: 'Activate Account',
    btnLoading: 'Activating...',
    errMatch: 'Passwords do not match!',
    errWeakPassword: '❌ Password must be at least 8 characters long, containing uppercase, lowercase, numbers, and special characters (#@$!).',
    successMsg: '✅ Account activated successfully! Redirecting...',
    errUnknown: '❌ Activation failed. The link may be expired.',

    // --- Account Settings ---
    settingsTitle: 'Account Settings ⚙️',
    labelCompany: 'Company Name',
    labelAdmin: 'Admin Name',
    labelEmail: 'Admin Email',
    labelCurrentPassword: 'Current Password 🔑',
    labelPassword: 'New Password',
    placeholderCurrentPass: 'Enter current password to allow changes',
    placeholderPass: 'Leave blank to keep current password',
    dangerZone: 'Danger Zone',
    btnDeleteAccount: 'Delete My Account',
    deleteConfirm: 'Are you sure you want to delete your personal account? (Company data will remain with support)',
    deleteErr: 'Error occurred during deletion. Please check server connection.',
    companyNote: 'Do you wish to delete the entire company? ',
    contactSupport: 'Contact Technical Support',
    valEmail: "❌ Please enter a valid email address",
    valCurrentPass: "❌ Please enter current password first to save changes",
    successUpdateSettings: "✅ Settings updated successfully",
    failUpdateSettings: "Failed to update settings",

    // --- Navigation & Layout ---
    mainMenu: "Main Menu",
    dashboard: "Dashboard",
    vendorsEntry: "Vendors Entry",
    banksList: "Banks List",
    addMember: "Add Member",
    manageMembers: "Manage Members",
    signOut: "Sign Out",
    daysLeft: "days left",
    mySettings: "My Settings",
    logout: "Logout",
    welcome: "Welcome back",
    adminAccess: "Full Admin permissions enabled.",
    employeeAccess: "Welcome to your control panel.",
    manageView: "Manage & View",
    noAccess: "Unauthorized",
    shareAccess: "Share Access",
    copied: "Link copied successfully!",
    digitalArchive: "Digital Archive",

    // --- Members Management ---
    membersTitle: 'Team Members Management',
    titleCreateMember: 'Create New Member',
    titleEditMember: 'Edit Permissions for: ',
    descCreateMember: 'Send an invitation to join a new team member',
    descEditMember: 'Modify access levels and roles for this user',
    labelName: 'Full Name',
    secRoles: 'Roles',
    secScreens: 'Screens',
    secActions: 'Actions',
    btnInvite: 'Send Email Invitation',
    thName: 'Name',
    thEmail: 'Email',
    thActions: 'Actions',
    noMembersData: 'No team members found.',
    confirmDeleteMember: 'Are you sure you want to delete member ',

    // --- Banks Management ---
    banksTitle: 'Banks & Financial Nodes',
    addBankBtn: '+ Add New Bank',
    location: '📍 Location:',
    swift: '🔑 SWIFT Code:',
    notDefined: 'Not Specified',
    update: '✏️ Edit',
    delete: '🗑️ Delete',
    noBanks: 'No banking nodes found.',
    loadingBanks: 'Loading banking systems...',
    addBankTitle: 'Add New Banking Node',
    updateBankTitle: 'Update Banking Node Info',
    namePlace: 'Bank Name',
    locPlace: 'Location (City, Country)',
    swiftPlace: 'SWIFT Code',
    saveBankNode: 'Save Financial Node',
    confirmDeleteBank: 'Are you sure you want to permanently delete this bank?',

    // --- Vendors Management ---
    vendorsTitle: 'Vendors & Partners',
    addVendorBtn: '+ Add New Vendor',
    notAvailable: 'Not Specified',
    updateVendorBtn: '✏️ Edit',
    deleteVendorBtn: '🗑️ Delete',
    confirmDeleteVendor: 'Are you sure you want to permanently delete this vendor?',
    modalAddVendor: 'Register New Vendor in System',
    modalUpdateVendor: 'Update Vendor Details',
    labelVendorName: 'Vendor / Company Name',
    placeVendorName: 'Enter vendor name here...',
    labelCountry: 'Country',
    placeCountry: 'Select country...',
    labelCity: 'City',
    placeCity: 'Select city...',
    placeAddress: 'Detailed Address',
    placeBuilding: 'Building / Floor',
    placeStreet: 'Street Name',
    placePhone: 'Phone Number',
    placeEmail: 'Email Address',
    placeWebsite: 'Website (Optional)',
    btnSaveVendor: 'Save Vendor',
    btnUpdateVendorSubmit: 'Update Data',
    vendorHeaderTitle: 'General Financial Overview',
    vendorHeaderSub: 'Displaying PI & CI Invoices for Vendor #',
    vendorSummaryTitle: 'Vendor Invoices Summary',
    vendorSummaryHeader: 'Vendors Summary',
    reportRequest: 'Request Comprehensive Report',
    vendorsHeaderNav: 'Dashboard / Vendors & Partners',
    statusActive: 'Status: Active',
    loadingVendorsSystem: 'Loading vendor banking systems...',
    vendorCardTitle: 'Associated Vendors & Invoices',
    linkVendorPlaceholder: '+ Link new vendor to this container',
    noInvoicesForVendor: 'No invoices registered for this vendor currently.',

    // --- Containers Management ---
    containerSearchPlaceholder: 'Search container...',
    btnAddContainer: '+ Add New Container',
    modalCreateContainer: 'Create New Container',
    modalEditContainer: 'Edit Container Info',
    lblSplit: 'Is this a partial / split container?',
    lblNumber: 'Container Number',
    lblPart: 'Sub-code / Part',
    alertBaseNum: 'Please enter base container number first',
    alertSuccessCreateContainer: 'Container created successfully ✅',
    alertSuccessUpdateContainer: 'Container updated successfully ✅',
    alertDeleteContainerConfirm: 'Are you sure you want to delete this container?',
    alertDeleteContainerFail: 'Deletion failed: You may lack necessary permissions',
    placeholderEx: 'e.g., 101',
    placeholderPart: 'A',
    unknownContainer: 'Unknown Container',
    updateBL: 'Update Bill of Lading (BL)',
    uploadBL: 'Upload Bill of Lading (BL)',

    // --- Invoices & COO ---
    "invoiceTitle": "Invoice & COO Entry Management",
  "archive": "📂 Stored Archive",
  "archiveTitle": "📂 Invoices Archive",
  "savedInvoices": "📁 Saved Invoices",
  "noSavedInvoices": "No saved invoices currently available",
  "docId": "📄 Document Identification",
  "invNo": "Invoice Number",
  "invDate": "Invoice Date",
  "cooNo": "COO Number",
  "cooDate": "COO Date",
  "cooInvNo": "Invoice No. in COO",
  "totalAmount": "Total Amount",
  "notMatch": "Numbers do not match financially!",
  "entities": "🤝 Entities & Items",
  "vendor": "Vendor",
  "selectVendor": "-- Select Vendor --",
  "bank": "Bank",
  "selectBank": "-- Select Bank --",
  "itemsBtn": "📦 Items Table",
  "integration": "⚡ Systems Integration",
  "selectManifest": "Select Manifest...",
  "checklistBtn": "📋 Checklist",
  "linkPi": "🔗 Link PI",
  "uploadTitle": "🚀 Smart File Upload Platform (Click for Instant Cloud Analysis)",
  "heroUploadZone": "🚀 Hero Upload Zone (Drag or Click to Analyze)",
  "accNo": "ACCOUNT NUMBER",
  "iban": "IBAN",
  "saveInvoiceBtn": "💾 SAVE INVOICE",
  "updateInvoiceBtn": "💾 UPDATE INVOICE",
  "noFile": "No file uploaded",
  "matchError": "⚠️ Match Error: Invoice Number must strictly match COO Invoice Number.",
  "selectVendorAlert": "Please select a vendor first!",
  "enterInvAlert": "Please enter the invoice number!",
  "enterManifestAlert": "Please select the manifest linked to this invoice!",
  "successSaveInvoice": "✅ Saved and submitted successfully!",
  "successUpdateInvoice": "✅ Invoice updated successfully!",
  "dataError": "Data structure error:",
  "saveFailedInvoice": "Save failed:",
  "combineBtn": "📦 Combine & Download Docs",
  "combineSub": "Generate Unified Shipment PDF",
  "scanning": "Analyzing invoice using AI...",
  "uploadCI": "Commercial Invoice (CI)",
  "uploadCOO": "Certificate of Origin (COO)",
  "uploadPL": "Packing List (PL)",
  "dropFiles": "Click to upload file to cloud",
  "analyzeBtn": "🤖 Run AI Extraction",
  "runAiExtraction": "Run AI Extraction",
  "selectCiAlert": "Please upload Commercial Invoice (CI) first to analyze!",

    // --- PI Invoices ---
    "pageTitle": "PI Invoice Entry",
    "titleEdit": "Edit PI Invoice",
    
    "btnBack": "Back",
    "btnRunAi": "Run AI Extraction",
    "btnCombineDocs": "Combine & Download Docs",
    "btnSaveInvoice": "Save Invoice",
    "btnUpdateInvoice": "Update Invoice",
    "btnCancel": "Cancel Edit",
    "btnViewSaved": "View Saved Invoices",
    
    "reqDocsTitle": "Required Documents (Click for AI Extraction after upload)",
    "extraDocsTitle": "Extra Docs",
    
    "docPiInvoice": "PI Invoice",
    "docPackingList": "Packing List",
    "docContract": "Contract",
    
    "lblPreManifest": "Pre-Manifest Number",
    "selectManifest": "Select Manifest...",
    "lblVendor": "Vendor",
    "selectVendor": "Select Vendor...",
    "lblInvoiceDate": "Invoice Date",
    "lblInvoiceNumber": "Invoice Number",
    "lblTotalAmount": "Total Amount / Number",
    
    "cardItemTable": "Item Table",
    "cardCheckList": "Check List",
    
    "savedDrawerTitle": "Saved Invoices",
    "noSavedInvoices": "No saved invoices found",
    
    "statusScanning": "Scanning...",
    "statusCombining": "Combining...",
    "statusProcessing": "Processing...",
    
    "aiSuccess": "✨ Bundle analyzed successfully by AI!",
    "aiFail": "❌ AI extraction failed",
    "noFilesErr": "❌ No uploaded files to combine!",
    "combineSuccess": "✨ Documents combined and downloaded successfully!",
    "combineFail": "❌ Failed to combine files. Ensure file formats are valid.",
    "noFileForAi": "⚠️ Please upload a PI Invoice or Packing List first to analyze!",
    "saveSuccess": "✅ Invoice saved successfully!",
    "saveFail": "❌ Failed to save invoice",
    "updateSuccess": "✅ Invoice updated successfully!",
    "deleteSuccess": "🗑 Invoice deleted successfully",
    "errInvNo": "❌ Invoice Number is required!",
    "errInvDate": "❌ Invoice Date is required!",
    "errAmount": "❌ Invalid Amount!",
    "errManifest": "❌ Please select Pre-Manifest Number!",
    "errVendor": "❌ Please select Vendor!",
    "errPiFile": "❌ Please upload PI Invoice file!",
    
    "typePI": "Proforma Invoice (PI)",
    "typeCI": "Commercial Invoice (CI)",

    // --- Manifests ---
    manifestTitle: 'Pre-Manifest Management',
    manifestPlaceholder: 'Enter Manifest or Bill Number...',
    thInfo: 'Manifest Information',
    thDetails: 'Linked Invoices Details',
    unknownVendor: 'Unknown',
    noLinked: 'No invoices currently linked to this manifest.',
    alertNumber: 'Please enter number first',
    alertDeleteManifestConfirm: 'Are you sure you want to delete this manifest record?',
    loadingManifests: 'Loading manifest data...',
    updateManifest: 'Update Manifest',
    uploadManifest: 'Upload Manifest',
    manifestConflictAlert: '⚠️ Warning: Invoices are linked to different manifest data!',
    noneManifestOption: '🫙 No Customs Manifest (None)',

    // --- Bank Transfers ---
    bankTransfersTitle: "Bank Transfers Management",
    invoice: "Invoice",
    fetching: "Fetching data...",
    searchInvoiceTitle: "🔍 Search Invoice",
    invoiceNoPlaceholder: "Invoice Number...",
    searchBtn: "Search Now",
    changeInvoiceBtn: "🔄 Search Another Invoice",
    paidAmount: "Paid Amount",
    remainingAmount: "Remaining Amount",
    invoiceDocs: "📄 Invoice Documents:",
    amountPlaceholder: "Amount",
    completedInvoice: "Invoice has been fully settled",
    previewMode: "⚠️ Quick View Mode - Upload available for current transfers only.",
    cancelledLabel: "(Cancelled)",
    alertNoInvoice: "Please enter invoice number first",
    alertFetchFail: "Failed to fetch invoice data.",
    alertSearchFail: "Invoice not found.",
    alertFileNotAvailable: "File not available yet.",
    alertNotAllowedSearch: "Action not permitted from search mode.",
    alertCompleted: "Completed.",
    alertInvalidAmount: "Invalid amount entered.",
    alertAddSuccess: "Added successfully ✅",
    alertAddFail: "Failed to add",
    alertSwiftSuccess: "SWIFT file uploaded successfully 🟢",
    alertSwiftFail: "Failed to upload SWIFT",
    alertCancelConfirm: "Are you sure you want to cancel this transfer financially?",
    alertCancelSuccess: "Transfer cancelled successfully 🛑",
    alertCancelFail: "Failed to cancel transfer",
    alertDeleteConfirm: "⚠️ Permanently delete this transfer from database?",
    alertDeleteSuccess: "Permanently deleted successfully 🗑️",
    alertDeleteFail: "Total deletion failed",
    alertDeleteSwiftConfirm: "Are you sure you want to delete SWIFT file?",
    alertDeleteSwiftSuccess: "SWIFT file deleted successfully ✅",
    alertDeleteSwiftFail: "Failed to delete SWIFT file",
    fullPayment: "Full Amount Paid",
    finalPayment: "Final Payment",

    // Bank Transfers Reports
    transfersReportTitle: 'Bank Transfers Sequence Report',
    transfersLegend: 'Green: SWIFT file successfully uploaded',
    amountPlace: 'Filter by amount...',
    loadingTransfersData: 'Loading transfer data...',
    noTransfersData: 'No transfers match the search criteria.',
    labelVendor: 'Vendor:',
    labelInvoice: 'Invoice:',
    labelAmount: 'Amount:',
    labelDate: 'Date:',
    statusCancelled: 'Cancelled',
    statusSwift: '✔ SWIFT',
    statusPending: 'Pending',
    textCancelled: '(Cancelled)',

    // --- Audit Log & Trash ---
    auditTitle: "System Activity Log & Data Recovery",
    trashBin: "🗑️ Trash Bin (Pending Recovery)",
    allActivities: "All Activities",
    bankAccounts: "Bank Accounts",
    vendors: "Vendors Management",
    containers: "Containers Management",
    invoices: "Commercial Invoices",
    piInvoices: "Proforma Invoices (PI)",
    bankTransfers: "Bank Transfers",
    manifests: "Manifests",
    preManifests: "Pre-Manifests",
    screens: "Screen Settings", 
    filterUser: "Search by employee...",
    filterStart: "From Date",
    filterEnd: "To Date",
    thUser: "Employee",
    thModule: "Screen / Module",
    thAction: "Action Type",
    thDetails: "Description & Details",
    thTimestamp: "Date & Time",
    thRecovery: "Recovery",
    noLogs: "No matching logs found.",
    restoredStatus: "Restored ✅",
    restoreBtn: "Restore",
    restoring: "Restoring...",
    confirmRestoreMsg: "Are you sure you want to restore this item?",
    successRestoreMsg: "Data restored successfully and returned to active screens!",
    errorRestoreMsg: "Error during restoration: ",
    audit: "Audit & Recovery",

    // --- Unified Documents Archive ---
    archiveUnifiedTitle: "Unified Documents & Files Archive",
    archiveUnifiedSubtitle: "Centralized overview of all files uploaded across system modules",
    totalFiles: "Total Archived Files",
    archiveSearchPlaceholder: "Search by file name or category (e.g., Bill of Lading, SWIFT)...",
    noDocs: "No documents or matching results found.",
    loadingArchive: "Loading unified digital archive...",
    tableName: "Original Document Name",
    tableType: "Category / Document Type",
    tableDate: "Upload Date & Time",
    tableActions: "Actions",
    viewBtn: "Open Document",

    // --- Common Actions & Alerts ---
    back: 'Back →',
    backBtn: 'Back',
    btnConfirm: 'Confirm Save',
    btnCancel: 'Cancel',
    cancel: 'Cancel',
    save: 'Save',
    btnSave: 'Save Changes',
    btnUpdate: 'Update Record',
    updateBtn: 'Edit',
    edit: 'Edit',
    btnEdit: 'Edit',
    btnDelete: 'Delete',
    linked: 'Linked ✓',
    unlinkTitle: 'Unlink Invoice',
    linkToContainer: 'Link to Container',
    newInvoice: 'New Invoice',
    saving: 'Saving...',
    confirmChanges: 'Confirm All Changes',
    confirmUnlinkInvoice: 'Are you sure you want to unlink this invoice?',
    alertUnlinkSuccess: 'Invoice unlinked successfully ✅',
    alertUnlinkError: 'Error occurred during unlinking',
    alertLinkManifestSuccess: 'Manifest linked to container successfully ✅',
    alertLinkManifestError: 'Error occurred while linking manifest',
    alertSaveSuccess: 'Saved successfully ✅',
    alertUploadSuccess: 'Files saved successfully!',
    confirmDeleteInvoice: '❌ Warning: Delete this invoice permanently from system?',
    alertDeleteSuccess: 'Invoice permanently deleted ✅',
    alertFailed: '❌ Action failed: ',
    alertSuccess: 'Action completed successfully ✅',
    successSave: '✅ Saved successfully',
    failDelete: '❌ Deletion failed',
    failSave: '❌ Error occurred while saving',
    loading: 'Loading data...',
    noData: 'No data to display',
    noDate: 'No date',
    lastModified: 'Last Modified',
    invoicesBadge: 'Invoices',
    errorMsg: 'An error occurred while fetching data.',
    searchPlace: 'Search...',
    searchPlaceholder: 'Search for vendor...',
    datePlace: 'Filter by date...',
    totalLabel: 'Total',
    thTotal: 'Total Amount',
    thPaid: 'Paid',
    thRemain: 'Remaining',
    thStatus: 'Status',
    thAction: 'Action',
    thId: 'ID',
    thInvoiceNo: 'Invoice No.',
    thDate: 'Date',
    btnPay: '+ Pay Now',
    viewDetails: '▼ View Details',
    closeDetails: '▲ Close Details',
  "title": "Bank Transfers Management",
    "invoice": "Invoice",
    "fetching": "Fetching...",
    "searchTitle": "🔍 Search for Invoice",
    "invoiceNoPlaceholder": "Invoice No...",
    "searchBtn": "Search Now",
    "changeInvoiceBtn": "🔄 Search for Another Invoice",
    "totalAmount": "Total Amount",
    "paidAmount": "Paid Amount",
    "remainingAmount": "Remaining",
    "invoiceDocs": "📁 All Associated Package Documents:",
    "amountPlaceholder": "Amount",
    "completedInvoice": "The invoice has been fully paid",
    "previewMode": "⚠️ Quick preview mode & upload only for current transfers.",
    "cancelledLabel": "(Cancelled)",
    "loading": "Updating data... ⏳",
    "alertNoInvoice": "Please enter invoice number first",
    "alertFetchFail": "Failed to fetch invoice data.",
    "alertSearchFail": "Invoice not found.",
    "alertFileNotAvailable": "File is not available yet.",
    "alertNotAllowedSearch": "Not allowed from search screen.",
    "alertCompleted": "Completed.",
    "alertInvalidAmount": "Invalid amount.",
    "alertAddSuccess": "Added successfully ✅",
    "alertAddFail": "Failed to add",
    "alertSwiftSuccess": "Swift file uploaded successfully and color turned green 🟢",
    "alertSwiftFail": "Failed to upload Swift",
    "alertCancelConfirm": "Are you sure you want to cancel the transfer financially?",
    "alertCancelSuccess": "Transfer cancelled successfully 🛑",
    "alertCancelFail": "Failed to cancel",
    "alertDeleteConfirm": "⚠️ Are you sure you want to permanently delete this transfer?",
    "alertDeleteSuccess": "Permanent deletion successful 🗑️",
    "alertDeleteFail": "Failed to delete",
    "alertDeleteSwiftConfirm": "Are you sure you want to delete the Swift file?",
    "alertDeleteSwiftSuccess": "Swift file deleted successfully ✅",
    "alertDeleteSwiftFail": "Failed to delete Swift",
    "alertUpdateSuccess": "Updated successfully ✅",
    "alertUpdateFail": "Failed to update",
    "fullPayment": "Full Payment",
    "finalPayment": "Final Payment",
    "firstBatch": "First Batch",
    "secondBatch": "Second Batch",
    "thirdBatch": "Third Batch",
    "fourthBatch": "Fourth Batch",
    "fifthBatch": "Fifth Batch",
    "extraBatch": "Extra Batch",
    "shareInvoice": "Share Invoice & Transfers 📲",
    "shareSuccess": "📋 All invoice and transfer details copied to clipboard!",
    "combining": "Combining and Downloading... ⏳",
    "combineBtn": "Combine & Download Selected Files",
    "attachFileErr": "Please attach the transfer file",
    "selectNewFileErr": "Please select the new transfer file first",
    "exceedsErr": "Error: Updated amount exceeds allowed invoice limit!",
    "exceedsRemainingErr": "Error: Input amount exceeds the remaining amount!",
    "vendor": "Vendor",
    "bank": "Bank",
    "cooNo": "COO No",
    "transfersCount": "Transfers Count",
    "price": "Amount:",
    "date": "Date:",
    "newFile": "New File:",
    "save": "Save",
    "cancel": "Cancel",
    "ready": "Ready ✅",
    "selectFile": "Select file",
    "docTypes": {
      "pi_invoice": "PI Invoice",
      "ci_invoice": "CI Invoice",
      "packing_list": "Packing List",
      "contract": "Contract",
      "coo": "COO Certificate",
      "vendor_license": "Vendor License",
      "bol": "Bill of Lading (B/L)",
      "manifest": "Manifest"
    },
    "title": "System Activity Logs & Recovery",
    "allActivities": "All Activities",
    "bankAccounts": "Bank Accounts",
    "vendorManagement": "Vendor Management",
    "containerManagement": "Container Management",
    "invoices": "Invoices",
    "piInvoices": "PI Invoices",
    "bankTransfers": "Bank Transfers",
    "manifests": "Manifests",
    "preManifests": "Pre-Manifests",
    "searchPlaceholder": "Search user, description or ID...",
    "from": "From",
    "to": "To",
    "clear": "Clear",
    "trashBin": "Trash Bin (Pending Restoration)",
    "colUser": "User / Employee",
    "colModule": "Module / Screen",
    "colAction": "Action Type",
    "colDescription": "Description & Details",
    "colTimestamp": "Timestamp",
    "colRecovery": "Recovery",
    "restored": "Restored",
    "restoring": "Restoring...",
    "restore": "Restore",
    "noLogs": "No matching logs found.",
    "system": "System",
    "trackingWindow.title": "System Activity Logs & Data Recovery",
  "trackingWindow.allActivities": "All Activities",
  "trackingWindow.bankAccounts": "Bank Accounts",
  "trackingWindow.vendorManagement": "Vendor Management",
  "trackingWindow.containerManagement": "Container Management",
  "trackingWindow.invoices": "Invoices",
  "trackingWindow.piInvoices": "Proforma Invoices (PI)",
  "trackingWindow.bankTransfers": "Bank Transfers",
  "trackingWindow.manifests": "Manifests",
  "trackingWindow.preManifests": "Pre-Manifests",
  "trackingWindow.searchPlaceholder": "Search employee, details, or ID...",
  "trackingWindow.from": "From",
  "trackingWindow.to": "To",
  "trackingWindow.clear": "Clear",
  "trackingWindow.trashBin": "Trash Bin (Pending Restoration Items)",
  "trackingWindow.colUser": "User / Employee",
  "trackingWindow.colModule": "Module / Screen",
  "trackingWindow.colAction": "Action Type",
  "trackingWindow.colDescription": "Description & Details",
  "trackingWindow.colTimestamp": "Timestamp",
  "trackingWindow.colRecovery": "Recovery",
  "trackingWindow.restored": "Restored",
  "trackingWindow.restoring": "Restoring...",
  "trackingWindow.restore": "Restore",
  "trackingWindow.noLogs": "No matching logs found.",
  "trackingWindow.system": "System",
  "invoiceDetails": {
    "title": "Invoice & COO Entry Management",
    "docId": "📄 Document Identification",
    "invNo": "Invoice Number",
    "invDate": "Invoice Date",
    "cooNo": "COO Number",
    "cooDate": "COO Date",
    "totalAmount": "Total Amount",
    "entities": "🤝 Entities & Bank Details",
    "vendor": "Vendor Name",
    "selectVendor": "-- Select Vendor --",
    "bank": "Bank",
    "selectBank": "-- Select Bank --",
    "accountNumber": "Account Number",
    "iban": "IBAN Number",
    "manifest": "Customs Manifest Number",
    "selectManifest": "-- Select Manifest (Mandatory if Container is None) --",
    "itemsBtn": "📦 Items Table",
    "checklistBtn": "📋 Checklist",
    "saveBtn": "💾 SAVE NEW INVOICE",
    "updateBtn": "💾 UPDATE EXISTING INVOICE",
    "enterInvAlert": "Please enter the invoice number!",
    "enterManifestAlert": "Please select or choose the Customs Manifest Number for this invoice!",
    "successSave": "✅ Saved successfully!",
    "successUpdate": "✅ Updated successfully!",
    "saveFailed": "Operation failed:",
    "scanning": "AI is scanning Invoice...",
    "uploadCI": "Commercial Invoice (CI)",
    "uploadCOO": "Certificate of Origin (COO)",
    "uploadPL": "Packing List (PL)",
    "analyzeBtn": "🤖 Analyze Invoice with AI",
    "selectCiAlert": "Please upload the Commercial Invoice (CI) first to analyze it!",
    "backBtn": "Back"
  }
}
  
  ;


    
